const USER_KEY = 'user'
let isRedirectingToLogin = false

export function getStoredUser() {
  const rawUser = localStorage.getItem(USER_KEY)
  if (!rawUser) {
    return null
  }
  try {
    return JSON.parse(rawUser)
  } catch (e) {
    clearLoginState()
    return null
  }
}

export function getAdminName(user) {
  if (!user) {
    return ''
  }
  const name = user.mName != null ? user.mName : (user.mname != null ? user.mname : user.MName)
  return name == null ? '' : String(name).trim()
}

export function getValidUser() {
  const storedUser = getStoredUser()
  if (!storedUser || !storedUser.data) {
    return null
  }
  if (storedUser.expires && Number(storedUser.expires) < Date.now()) {
    clearLoginState()
    return null
  }
  return storedUser.data
}

export function clearLoginState() {
  localStorage.removeItem(USER_KEY)
}

/** 用于 axios 拦截器：会话失效时静默跳转，避免各页面 catch 再弹错误提示 */
export function createAuthExpiredError() {
  const err = new Error('SESSION_EXPIRED')
  err.isAuthExpired = true
  return err
}

export function isAuthExpiredError(err) {
  return !!(err && err.isAuthExpired)
}

export function logoutAndRedirect(router) {
  clearLoginState()
  if (isRedirectingToLogin) {
    return
  }
  const currentPath = router && router.currentRoute ? router.currentRoute.path : ''
  if (currentPath === '/login') {
    return
  }
  isRedirectingToLogin = true
  router.replace('/login')
      .catch(() => {})
      .finally(() => {
        isRedirectingToLogin = false
      })
}
